import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  TextField, 
  Container, 
  Grid, 
  Card, 
  CardContent,
  useTheme,
  useMediaQuery,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material';
import { Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material';

const LaunchReadySplashPage = () => {
  const [email, setEmail] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    alert('Newsletter subscription submitted!');
    setEmail('');
  };

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <Box sx={{
      fontFamily: 'Poppins, sans-serif',
      backgroundColor: '#FFFFFF',
      width: '100%',
      minHeight: '100vh',
      margin: 0,
      padding: 0,
    }}>
      
      {/* Navigation */}
      <Box sx={{
        width: '100%',
        height: { xs: '70px', md: '96px' },
        backgroundColor: '#FFFFFF',
        padding: { xs: '12px 16px', md: '16px 48px' },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000,
        borderBottom: '1px solid #f0f0f0',
      }}>
        {/* Logo */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}>
          <img 
            src="/UnisynHub/Assets/Group 8.svg" 
            alt="BareBiologics Logo" 
            style={{
              width: isMobile ? '40px' : '59px',
              height: isMobile ? '44px' : '64px',
            }}
          />
          <Typography sx={{
            fontSize: '30.667px',
            fontFamily: 'Poppins',
            fontWeight: '700',
            color: '#01544E',
            lineHeight: 'normal',
          }}>
            UnisynHub
          </Typography>
        </Box>

        {/* Desktop Navigation Links */}
        {!isMobile && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '32px',
          }}>
            {/* <a href="#about" style={{
              color: '#333333',
              fontSize: '16px',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '400',
              textDecoration: 'none',
            }}>About</a>
            <a href="#insights" style={{
              color: '#333333',
              fontSize: '16px',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '400',
              textDecoration: 'none',
            }}>Insights</a>
            <a href="#contact" style={{
              color: '#333333',
              fontSize: '16px',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '400',
              textDecoration: 'none',
            }}>Contact Us</a> */}
            
            <Button 
              href="#/login"
              sx={{
                padding: '14px 32px',
                backgroundColor: '#FFFFFF',
                border: '2px solid #039582',
                borderRadius: '43px',
                color: '#039582',
                fontSize: '14px',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: '600',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#f0fdfa',
                }
              }}
            >
              Sign In
            </Button>
            
            <Button 
              onClick={() => window.location.href = '#/signup'}
              sx={{
                padding: '14px 32px',
                backgroundColor: '#039582',
                borderRadius: '43px',
                color: '#FFFFFF',
                fontSize: '14px',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: '600',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#027A6B',
                }
              }}
            >
              Sign Up
            </Button>
          </Box>
        )}

        {/* Mobile Menu Button */}
        {isMobile && (
          <IconButton
            onClick={handleMobileMenuToggle}
            sx={{
              color: '#039582',
            }}
          >
            <MenuIcon />
          </IconButton>
        )}
      </Box>

      {/* Mobile Menu Drawer */}
      <Drawer
        anchor="right"
        open={mobileMenuOpen}
        onClose={handleMobileMenuToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: 280,
            padding: 2,
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h6" sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600 }}>
            Menu
          </Typography>
          <IconButton onClick={handleMobileMenuToggle}>
            <CloseIcon />
          </IconButton>
        </Box>

        <List>
          {/* {['About', 'Insights', 'Contact Us'].map((text) => (
            <ListItem key={text} disablePadding>
              <ListItemButton sx={{ py: 1.5 }}>
                <ListItemText
                  primary={text}
                  sx={{
                    fontFamily: 'Poppins, sans-serif',
                    '& .MuiListItemText-primary': {
                      fontSize: '16px',
                      fontWeight: 400,
                    }
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))} */}
        </List>
        
        <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button 
            href="#/login"
            fullWidth
            sx={{
              padding: '14px 32px',
              backgroundColor: '#FFFFFF',
              border: '2px solid #039582',
              borderRadius: '43px',
              color: '#039582',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '600',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#f0fdfa',
              }
            }}
          >
            Sign In
          </Button>
          
          <Button 
            onClick={() => window.location.href = '#/signup'}
            fullWidth
            sx={{
              padding: '14px 32px',
              backgroundColor: '#039582',
              borderRadius: '43px',
              color: '#FFFFFF',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '600',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#027A6B',
              }
            }}
          >
            Sign Up
          </Button>
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box sx={{
        marginTop: { xs: '70px', md: '96px' },
        width: '100%',
      }}>
        
        {/* Hero Product Cards */}
        <Container maxWidth="xl" sx={{ py: { xs: 3, md: 6 }, px: { xs: 2, md: 6 } }}>
          <Grid container spacing={{ xs: 3, md: 2 }} justifyContent={{ xs: 'center', md: 'flex-start' }}>
            <Grid item xs={12}>
              <Typography
                sx={{
                  color: '#000',
                  fontFamily: 'Poppins',
                  fontSize: '24px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: 'normal',
                  mb: { xs: 2, md: 3 },
                }}
              >
                Shop Available Products
              </Typography>
            </Grid>
            {/* Lipoderma™ Card */}
            <Grid item xs={12} md={6} lg={5.9}>
              <Card
                sx={{
                  height: { xs: '250px', sm: '300px', md: '450px' },
                  backgroundImage: 'url("/UnisynHub/Assets/lipoderma-card.png")',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  }
                }}
                onClick={() => window.location.href = '#/signup?product=lipoderma'}
              />
            </Grid>

            {/* equicenta™ CTM Card */}
            <Grid item xs={12} md={6} lg={5.9} sx={{ ml: { lg: 'auto' } }}>
              <Card
                sx={{
                  height: { xs: '250px', sm: '300px', md: '450px' },
                  backgroundImage: 'url("/UnisynHub/Assets/equicenta-card.png")',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                  position: 'relative',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  }
                }}
                onClick={() => window.location.href = '#/signup?product=equicent'}
              >
                {/* NEW Badge */}
                <Box sx={{
                  position: 'absolute',
                  top: { xs: '12px', md: '20px' },
                  right: { xs: '12px', md: '20px' },
                  backgroundColor: '#13CDBE',
                  color: '#FFFFFF',
                  fontSize: { xs: '10px', md: '12px' },
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: '600',
                  padding: { xs: '4px 8px', md: '6px 12px' },
                  borderRadius: '4px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                }}>
                  NEW
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Container>

        {/* Featured Section */}
        <Container maxWidth="xl" sx={{ py: { xs: 3, md: 5 }, px: { xs: 2, md: 6 } }}>
          <Card sx={{
            backgroundColor: '#FFFFFF',
            borderRadius: '8px',
            boxShadow: '0px 8px 40px 0px rgba(0, 38, 3, 0.08)',
            padding: { xs: 2, md: 5 },
            minHeight: { xs: 'auto', md: '128px' },
          }}>
            <Grid container spacing={{ xs: 2, md: 4 }} alignItems="center" justifyContent="flex-start">
              {/* Free Shipping */}
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  justifyContent: { xs: 'center', sm: 'flex-start' },
                  width: '100%',
                }}>
                  <Box sx={{
                    width: '40px',
                    height: '40px',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img
                      src="/UnisynHub/Assets/delivery-truck 1.svg"
                      alt="Free Shipping"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  </Box>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    gap: 0.5,
                    flex: 1,
                    minWidth: 0,
                  }}>
                    <Typography sx={{
                      color: '#1A1A1A',
                      fontFamily: 'Poppins',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      lineHeight: '120%',
                    }}>
                      Free Shipping
                    </Typography>
                    <Typography sx={{
                      color: '#333',
                      fontFamily: 'Poppins',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: '400',
                      lineHeight: '150%',
                    }}>
                      Free shipping on select orders
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* 100% Secure Payment */}
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  justifyContent: { xs: 'center', sm: 'flex-start' },
                  width: '100%',
                }}>
                  <Box sx={{
                    width: '40px',
                    height: '40px',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img
                      src="/UnisynHub/Assets/shopping-bag.svg"
                      alt="100% Secure Payment"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  </Box>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    gap: 0.5,
                    flex: 1,
                    minWidth: 0,
                  }}>
                    <Typography sx={{
                      color: '#1A1A1A',
                      fontFamily: 'Poppins',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      lineHeight: '120%',
                    }}>
                      100% Secure Payment
                    </Typography>
                    <Typography sx={{
                      color: '#333',
                      fontFamily: 'Poppins',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: '400',
                      lineHeight: '150%',
                    }}>
                      We ensure your money is safe
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Pre-pay Discounts */}
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  justifyContent: { xs: 'center', sm: 'flex-start' },
                  width: '100%',
                }}>
                  <Box sx={{
                    width: '40px',
                    height: '40px',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img
                      src="/UnisynHub/Assets/package.svg"
                      alt="Pre-pay Discounts"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  </Box>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    gap: 0.5,
                    flex: 1,
                    minWidth: 0,
                  }}>
                    <Typography sx={{
                      color: '#1A1A1A',
                      fontFamily: 'Poppins',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      lineHeight: '120%',
                    }}>
                      Pre-pay Discounts
                    </Typography>
                    <Typography sx={{
                      color: '#333',
                      fontFamily: 'Poppins',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: '400',
                      lineHeight: '150%',
                    }}>
                      Net terms available
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Customer Support 24/7 */}
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  justifyContent: { xs: 'center', sm: 'flex-start' },
                  width: '100%',
                }}>
                  <Box sx={{
                    width: '40px',
                    height: '40px',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img
                      src="/UnisynHub/Assets/headphones 1.svg"
                      alt="Customer Support 24/7"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  </Box>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    gap: 0.5,
                    flex: 1,
                    minWidth: 0,
                  }}>
                    <Typography sx={{
                      color: '#1A1A1A',
                      fontFamily: 'Poppins',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      lineHeight: '120%',
                    }}>
                      Customer Support 24/7
                    </Typography>
                    <Typography sx={{
                      color: '#333',
                      fontFamily: 'Poppins',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: '400',
                      lineHeight: '150%',
                    }}>
                      Instant access to Support
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Container>

        {/* Product About Sections */}
        <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 }, px: { xs: 2, md: 6 } }}>
          {/* Mobile/Tablet Layout - Cards */}
          <Grid container spacing={2} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }}>
            {/* Card 1: About equicenta™ CTM Text */}
            <Grid item xs={12} sm={12}>
              <Box sx={{
                backgroundColor: '#E4FFFD',
                padding: { xs: 3, sm: 5 },
                height: { xs: '400px', sm: '450px' },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                borderRadius: '8px',
              }}>
                <Typography sx={{
                  color: '#111827',
                  fontFeatureSettings: "'liga' off",
                  fontFamily: 'Poppins',
                  fontSize: { xs: '36px', sm: '48px' },
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: { xs: '45px', sm: '60px' },
                  letterSpacing: '-1.2px',
                  mb: 2,
                }}>
                  About equicenta™ CTM
                </Typography>
                <Typography sx={{
                  color: '#111827',
                  fontFeatureSettings: "'liga' off",
                  fontFamily: 'Poppins',
                  fontSize: { xs: '16px', sm: '18px' },
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: { xs: '24px', sm: '28px' },
                  mb: 3,
                }}>
                  A first-in-class, injectable, cryopreserved microparticulate equine umbilical cord tissue allograft, designed for equine joints, tendons and ligaments. Delivered as a ready-to-use, protein-rich suspension. Create an account to order today!
                </Typography>
                <Button
                  onClick={() => window.location.href = '#/signup'}
                  sx={{
                    padding: '14px 32px',
                    backgroundColor: '#039582',
                    borderRadius: '43px',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '600',
                    textTransform: 'none',
                    width: 'fit-content',
                    '&:hover': {
                      backgroundColor: '#027A6B',
                    }
                  }}
                >
                  Create Account
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '8px' }}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Button>
              </Box>
            </Grid>

            {/* Card 2: equicenta™ CTM Image */}
            <Grid item xs={12} sm={12}>
              <Box sx={{
                height: { xs: '400px', sm: '450px' },
                backgroundImage: 'url("/UnisynHub/Assets/equi-splash2.png")',
                backgroundSize: '100% 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderRadius: '8px',
              }} />
            </Grid>

            {/* Card 3: About Lipoderma™ Text */}
            <Grid item xs={12} sm={12}>
              <Box sx={{
                backgroundColor: '#E4FFFD',
                padding: { xs: 3, sm: 5 },
                height: { xs: '400px', sm: '450px' },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                borderRadius: '8px',
              }}>
                <Typography sx={{
                  color: '#111827',
                  fontFeatureSettings: "'liga' off",
                  fontFamily: 'Poppins',
                  fontSize: { xs: '36px', sm: '48px' },
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: { xs: '45px', sm: '60px' },
                  letterSpacing: '-1.2px',
                  mb: 2,
                }}>
                  About Lipoderma™
                </Typography>
                <Typography sx={{
                  color: '#111827',
                  fontFeatureSettings: "'liga' off",
                  fontFamily: 'Poppins',
                  fontSize: { xs: '16px', sm: '18px' },
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: { xs: '24px', sm: '28px' },
                  mb: 3,
                }}>
                  Lipoderma™ is an adipose tissue allograft that is implanted where fat naturally exists to restore volume where fat loss occurs. Create an account to order today!
                </Typography>
                <Button
                  onClick={() => window.location.href = '#/signup'}
                  sx={{
                    padding: '14px 32px',
                    backgroundColor: '#039582',
                    borderRadius: '43px',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '600',
                    textTransform: 'none',
                    width: 'fit-content',
                    '&:hover': {
                      backgroundColor: '#027A6B',
                    }
                  }}
                >
                  Create Account
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '8px' }}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Button>
              </Box>
            </Grid>

            {/* Card 4: Lipoderma™ Image */}
            <Grid item xs={12} sm={12}>
              <Box sx={{
                height: { xs: '400px', sm: '450px' },
                backgroundImage: 'url("/UnisynHub/Assets/lipo-splash.png")',
                backgroundSize: '100% 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderRadius: '8px',
              }} />
            </Grid>
          </Grid>

          {/* Desktop Layout - Rows */}
          <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
            {/* Top Row - equicenta™ CTM */}
            <Box sx={{
              display: 'flex',
              height: '650px',
              alignItems: 'center',
              gap: 0,
              flexDirection: 'row',
              mb: 0,
            }}>
              {/* Text Panel */}
              <Box sx={{
                backgroundColor: '#E4FFFD',
                padding: '102px',
                paddingRight: '102px',
                flex: '1 1 50%',
                width: '50%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
                <Typography sx={{
                  color: '#111827',
                  fontFeatureSettings: "'liga' off",
                  fontFamily: 'Poppins',
                  fontSize: '48px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '60px',
                  letterSpacing: '-1.2px',
                  mb: 2,
                }}>
                  About equicenta™ CTM
                </Typography>
                <Typography sx={{
                  color: '#111827',
                  fontFeatureSettings: "'liga' off",
                  fontFamily: 'Poppins',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '28px',
                  mb: 3,
                }}>
                  A first-in-class, injectable, cryopreserved microparticulate equine umbilical cord tissue allograft, designed for equine joints, tendons and ligaments. Delivered as a ready-to-use, protein-rich suspension. Create an account to order today!
                </Typography>
                <Button
                  onClick={() => window.location.href = '#/signup'}
                  sx={{
                    padding: '14px 32px',
                    backgroundColor: '#039582',
                    borderRadius: '43px',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '600',
                    textTransform: 'none',
                    width: 'fit-content',
                    '&:hover': {
                      backgroundColor: '#027A6B',
                    }
                  }}
                >
                  Create Account
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '8px' }}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Button>
              </Box>

              {/* Image Panel */}
              <Box sx={{
                flex: '1 1 50%',
                width: '50%',
                height: '100%',
                backgroundImage: 'url("/UnisynHub/Assets/equi-splash2.png")',
                backgroundSize: '100% 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }} />
            </Box>

            {/* Bottom Row - Lipoderma™ */}
            <Box sx={{
              display: 'flex',
              height: '650px',
              alignItems: 'center',
              gap: 0,
              flexDirection: 'row',
              mt: 0,
            }}>
              {/* Image Panel */}
              <Box sx={{
                flex: '1 1 50%',
                width: '50%',
                height: '100%',
                backgroundImage: 'url("/UnisynHub/Assets/lipo-splash.png")',
                backgroundSize: '100% 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }} />

              {/* Text Panel */}
              <Box sx={{
                backgroundColor: '#E4FFFD',
                padding: '102px',
                paddingLeft: '102px',
                flex: '1 1 50%',
                width: '50%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
                <Typography sx={{
                  color: '#111827',
                  fontFeatureSettings: "'liga' off",
                  fontFamily: 'Poppins',
                  fontSize: '48px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '60px',
                  letterSpacing: '-1.2px',
                  mb: 2,
                }}>
                  About Lipoderma™
                </Typography>
                <Typography sx={{
                  color: '#111827',
                  fontFeatureSettings: "'liga' off",
                  fontFamily: 'Poppins',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '28px',
                  mb: 3,
                }}>
                  Lipoderma™ is an adipose tissue allograft that is implanted where fat naturally exists to restore volume where fat loss occurs. Create an account to order today!
                </Typography>
                <Button
                  onClick={() => window.location.href = '#/signup'}
                  sx={{
                    padding: '14px 32px',
                    backgroundColor: '#039582',
                    borderRadius: '43px',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '600',
                    textTransform: 'none',
                    width: 'fit-content',
                    '&:hover': {
                      backgroundColor: '#027A6B',
                    }
                  }}
                >
                  Create Account
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '8px' }}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Button>
              </Box>
            </Box>
          </Box>
        </Container>

        {/* Tailor-made Ordering Section */}
        <Box sx={{
          width: '100%',
          backgroundColor: '#EDF2EE',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 4, md: 6 },
          px: { xs: 2, md: 6 },
        }}>
          <Container maxWidth="lg" sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
            <Typography sx={{
              fontSize: { xs: '32px', sm: '40px', md: '48px' },
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '700',
              lineHeight: { xs: '40px', sm: '50px', md: '60px' },
              color: '#111827',
              mb: 1,
            }}>
              Tailor-made Ordering
            </Typography>
            <Typography sx={{
              fontSize: { xs: '16px', md: '18px' },
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '400',
              lineHeight: { xs: '24px', md: '28px' },
              color: '#111827',
            }}>
              Exclusive ordering access designed to make buying regenerative products simple, fast, and reliable.
            </Typography>
          </Container>

          <Container maxWidth="lg">
            <Grid container spacing={{ xs: 3, md: 4 }}>
              {/* Seamless Workflow */}
              <Grid item xs={12} sm={6}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 3,
                  textAlign: 'center',
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img
                      src="/UnisynHub/Assets/featureIcon1.svg"
                      alt="Seamless Workflow"
                      style={{
                        width: '32px',
                        height: '32px',
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography sx={{
                      fontSize: { xs: '24px', md: '30px' },
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '700',
                      lineHeight: { xs: '32px', md: '40px' },
                      color: '#111827',
                      mb: 1,
                    }}>
                      Seamless Workflow
                    </Typography>
                    <Typography sx={{
                      fontSize: { xs: '14px', md: '16px' },
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '400',
                      lineHeight: { xs: '20px', md: '24px' },
                      color: '#374151',
                    }}>
                      Automated ordering, fulfillment, and tracking to keep operations running smoothly with fewer clicks.
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Reliable Fulfillment */}
              <Grid item xs={12} sm={6}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 3,
                  textAlign: 'center',
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img
                      src="/UnisynHub/Assets/featureIcon2.svg"
                      alt="Reliable Fulfillment"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography sx={{
                      fontSize: { xs: '24px', md: '30px' },
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '700',
                      lineHeight: { xs: '32px', md: '40px' },
                      color: '#111827',
                      mb: 1,
                    }}>
                      Reliable Fulfillment
                    </Typography>
                    <Typography sx={{
                      fontSize: { xs: '14px', md: '16px' },
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '400',
                      lineHeight: { xs: '20px', md: '24px' },
                      color: '#374151',
                    }}>
                      Fast, secure shipping with real-time order tracking
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Dedicated Support */}
              <Grid item xs={12} sm={6}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 3,
                  textAlign: 'center',
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img
                      src="/UnisynHub/Assets/featureIcon3.svg"
                      alt="Dedicated Support"
                      style={{
                        width: '27px',
                        height: '32px',
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography sx={{
                      fontSize: { xs: '24px', md: '30px' },
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '700',
                      lineHeight: { xs: '32px', md: '40px' },
                      color: '#111827',
                      mb: 1,
                    }}>
                      Dedicated Support
                    </Typography>
                    <Typography sx={{
                      fontSize: { xs: '14px', md: '16px' },
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '400',
                      lineHeight: { xs: '20px', md: '24px' },
                      color: '#374151',
                    }}>
                      Our team is here to answer questions and help with product selection
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Trusted Quality */}
              <Grid item xs={12} sm={6}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 3,
                  textAlign: 'center',
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img
                      src="/UnisynHub/Assets/featureIcon4.svg"
                      alt="Trusted Quality"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography sx={{
                      fontSize: { xs: '24px', md: '30px' },
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '700',
                      lineHeight: { xs: '32px', md: '40px' },
                      color: '#111827',
                      mb: 1,
                    }}>
                      Trusted Quality
                    </Typography>
                    <Typography sx={{
                      fontSize: { xs: '14px', md: '16px' },
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '400',
                      lineHeight: { xs: '20px', md: '24px' },
                      color: '#374151',
                    }}>
                      FDA 361-compliant products backed by safety studies
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* Testimonials Section */}
        <Box sx={{
          width: '100%',
          backgroundColor: '#FFFFFF',
          py: { xs: 4, md: 8 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <Container maxWidth="xl" sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
            <Typography sx={{
              fontSize: { xs: '28px', sm: '36px', md: '40px' },
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '600',
              lineHeight: { xs: '36px', sm: '44px', md: '48px' },
              color: '#002603',
              mb: { xs: 4, md: 6 },
            }}>
              Products with Real-Life Impact
            </Typography>
            
            <Grid container spacing={{ xs: 3, md: 2 }} justifyContent="center">
              {/* Testimonial 1 - Dr. Chen */}
              <Grid item xs={12} sm={6} lg={4}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
                }}>
                  <Card sx={{
                    width: '100%',
                    minHeight: { xs: '200px', md: '240px' },
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    border: 'none',
                    boxShadow: 'none',
                    position: 'relative',
                    p: { xs: 2, md: 4 },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    '&:hover': {
                      boxShadow: 'none',
                      transform: 'none',
                    },
                  }}>
                    <Box sx={{
                      width: '40px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <img
                        src="/UnisynHub/Assets/Vector.svg"
                        alt="Quote icon"
                        style={{
                          width: '40px',
                          height: '32px',
                        }}
                      />
                    </Box>
                    
                    <Typography sx={{
                      color: '#406B42',
                      textAlign: 'center',
                      fontFamily: 'Poppins',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '150%',
                    }}>
                      "Lipoderma has made a remarkable difference for my patients seeking natural, subtle volume restoration. It's become a go-to treatment in my clinic."
                    </Typography>
                  </Card>

                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1.5,
                  }}>
                    <Box sx={{
                      width: { xs: '48px', md: '64px' },
                      height: { xs: '48px', md: '64px' },
                      borderRadius: '50%',
                      backgroundImage: 'url("/UnisynHub/Assets/dr-chen.png")',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }} />
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography sx={{
                        fontSize: { xs: '14px', md: '16px' },
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '500',
                        lineHeight: { xs: '20px', md: '24px' },
                        color: '#002603',
                      }}>
                        Dr. Chen
                      </Typography>
                      <Typography sx={{
                        fontSize: { xs: '12px', md: '14px' },
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '400',
                        lineHeight: { xs: '18px', md: '21px' },
                        color: '#618062',
                      }}>
                        Beverly Hills, CA
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* Testimonial 2 - Guy Hawkins */}
              <Grid item xs={12} sm={6} lg={4}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
                }}>
                  <Card sx={{
                    width: '100%',
                    minHeight: { xs: '200px', md: '240px' },
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    border: 'none',
                    boxShadow: 'none',
                    position: 'relative',
                    p: { xs: 2, md: 4 },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    '&:hover': {
                      boxShadow: 'none',
                      transform: 'none',
                    },
                  }}>
                    <Box sx={{
                      width: '40px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <img
                        src="/UnisynHub/Assets/Vector.svg"
                        alt="Quote icon"
                        style={{
                          width: '40px',
                          height: '32px',
                        }}
                      />
                    </Box>
                    
                    <Typography sx={{
                      color: '#406B42',
                      textAlign: 'center',
                      fontFamily: 'Poppins',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '150%',
                    }}>
                      "Equicenta CTM has elevated the level of care we can provide to equine athletes. It's easy to use, safe, and consistently delivers great results."
                    </Typography>
                  </Card>

                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1.5,
                  }}>
                    <Box sx={{
                      width: { xs: '48px', md: '64px' },
                      height: { xs: '48px', md: '64px' },
                      borderRadius: '50%',
                      backgroundImage: 'url("/UnisynHub/Assets/guy-hawkins.png")',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }} />
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography sx={{
                        fontSize: { xs: '14px', md: '16px' },
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '500',
                        lineHeight: { xs: '20px', md: '24px' },
                        color: '#002603',
                      }}>
                        Guy Hawkins
                      </Typography>
                      <Typography sx={{
                        fontSize: { xs: '12px', md: '14px' },
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '400',
                        lineHeight: { xs: '18px', md: '21px' },
                        color: '#618062',
                      }}>
                        Customer
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* Testimonial 3 - Kathryn Murphy */}
              <Grid item xs={12} sm={6} lg={4}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
                }}>
                  <Card sx={{
                    width: '100%',
                    minHeight: { xs: '200px', md: '240px' },
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    border: 'none',
                    boxShadow: 'none',
                    position: 'relative',
                    p: { xs: 2, md: 4 },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    '&:hover': {
                      boxShadow: 'none',
                      transform: 'none',
                    },
                  }}>
                    <Box sx={{
                      width: '40px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <img
                        src="/UnisynHub/Assets/Vector.svg"
                        alt="Quote icon"
                        style={{
                          width: '40px',
                          height: '32px',
                        }}
                      />
                    </Box>
                    
                    <Typography sx={{
                      color: '#406B42',
                      textAlign: 'center',
                      fontFamily: 'Poppins',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '150%',
                    }}>
                      "Nam sed odio diam. Mauris sagittis sapien sed convallis cursus. Proin mattis ultrices urna ac eleifend. Cras vel nisi nec lectus sagittis venenatis. Curabitur laoreet leo sed lorem pulvina"
                    </Typography>
                  </Card>

                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1.5,
                  }}>
                    <Box sx={{
                      width: { xs: '48px', md: '64px' },
                      height: { xs: '48px', md: '64px' },
                      borderRadius: '50%',
                      backgroundImage: 'url("/UnisynHub/Assets/kathryn-murphy.png")',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }} />
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography sx={{
                        fontSize: { xs: '14px', md: '16px' },
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '500',
                        lineHeight: { xs: '20px', md: '24px' },
                        color: '#002603',
                      }}>
                        Kathryn Murphy
                      </Typography>
                      <Typography sx={{
                        fontSize: { xs: '12px', md: '14px' },
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '400',
                        lineHeight: { xs: '18px', md: '21px' },
                        color: '#618062',
                      }}>
                        Customer
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* Video Section - Commented out for later work */}
        {/* 
        <Box sx={{
          width: '100%',
          py: { xs: 3, md: 4 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 3, md: 4 },
        }}>
          <Container maxWidth="xl">
            <Box sx={{
              width: '100%',
              height: { xs: '300px', sm: '400px', md: '500px', lg: '740px' },
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
              backgroundImage: 'url("/UnisynHub/Assets/v1-splash-page.jpg")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 46, 3, 0.7)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: { xs: 2, md: 4 },
              }}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1.5,
                }}>
                  <Typography sx={{
                    fontSize: { xs: '14px', md: '16px' },
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '400',
                    lineHeight: { xs: '14px', md: '16px' },
                    color: '#FFFFFF',
                  }}>
                    Video
                  </Typography>
                  <Typography sx={{
                    fontSize: { xs: '24px', sm: '30px', md: '36px' },
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '600',
                    lineHeight: { xs: '30px', sm: '36px', md: '43.2px' },
                    color: '#FFFFFF',
                    textAlign: 'center',
                  }}>
                    How It Works
                  </Typography>
                </Box>
                
                <Button sx={{
                  width: { xs: '60px', md: '80px' },
                  height: { xs: '60px', md: '80px' },
                  borderRadius: '50%',
                  border: '1.5px solid #FFFFFF',
                  backgroundColor: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.2)',
                  },
                }}>
                  <svg width="20" height="24" viewBox="0 0 20 24" fill="none">
                    <path d="M2 2L18 12L2 22V2Z" fill="#FFFFFF"/>
                  </svg>
                </Button>
              </Box>
            </Box>
          </Container>

          Have Questions CTA
          <Box sx={{
            width: '100%',
            minHeight: { xs: '200px', md: '327px' },
            backgroundColor: '#D0FFFB',
            py: { xs: 4, md: 8 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <Container maxWidth="md">
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 3,
                textAlign: 'center',
              }}>
                <Typography sx={{
                  fontSize: { xs: '28px', sm: '36px', md: '40px' },
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: '600',
                  lineHeight: { xs: '36px', sm: '44px', md: '48px' },
                  color: '#111827',
                }}>
                  Have questions?
                </Typography>
                <Typography sx={{
                  fontSize: { xs: '14px', md: '16px' },
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: '500',
                  lineHeight: { xs: '20px', md: '24px' },
                  color: '#111827',
                }}>
                  Our team is here to help you!
                </Typography>
                <Button sx={{
                  width: { xs: '140px', md: '170px' },
                  height: { xs: '45px', md: '51px' },
                  backgroundColor: '#039582',
                  borderRadius: '43px',
                  color: '#FFFFFF',
                  fontSize: { xs: '14px', md: '16px' },
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: '600',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#028c77',
                  },
                }}>
                  Contact Us
                </Button>
              </Box>
            </Container>
          </Box>
        </Box>
        */}
      </Box>

      {/* Newsletter Section */}
      <Box sx={{
        width: '100%',
        backgroundColor: '#F7F7F7',
        py: { xs: 3, md: 4 },
        px: { xs: 2, md: 6 },
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        alignItems: { xs: 'center', lg: 'flex-start' },
        justifyContent: 'space-between',
        gap: { xs: 3, md: 4 },
      }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          textAlign: { xs: 'center', lg: 'left' },
          maxWidth: { xs: '100%', lg: '500px' },
        }}>
          <Typography sx={{
            fontSize: { xs: '20px', md: '24px' },
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '600',
            lineHeight: { xs: '28px', md: '36px' },
            color: '#333333',
          }}>
            Subscribe to our Newsletter
          </Typography>
          <Typography sx={{
            fontSize: { xs: '12px', md: '14px' },
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '400',
            lineHeight: { xs: '18px', md: '21px' },
            color: '#333333',
            maxWidth: { xs: '100%', md: '448px' },
          }}>
            Pellentesque eu nibh eget mauris congue mattis mattis nec tellus. Phasellus imperdiet elit eu magna.
          </Typography>
        </Box>

        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          gap: 2,
          width: { xs: '100%', sm: 'auto' },
          maxWidth: { xs: '400px', sm: 'auto' },
        }}>
          <TextField
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={{
              width: { xs: '100%', sm: '280px', md: '387px' },
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#FFFFFF',
                borderRadius: '46px',
                height: { xs: '48px', md: '52px' },
                '& fieldset': {
                  borderColor: '#E6E6E6',
                },
                '&:hover fieldset': {
                  borderColor: '#039582',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#039582',
                },
              },
              '& .MuiOutlinedInput-input': {
                padding: { xs: '12px 20px', md: '14px 24px' },
                fontSize: { xs: '14px', md: '16px' },
                fontFamily: 'Poppins, sans-serif',
                color: '#808080',
              },
            }}
          />
          <Button
            type="submit"
            onClick={handleNewsletterSubmit}
            sx={{
              width: { xs: '100%', sm: '140px', md: '162px' },
              height: { xs: '48px', md: '52px' },
              backgroundColor: '#039582',
              borderRadius: '43px',
              color: '#FFFFFF',
              fontSize: { xs: '14px', md: '16px' },
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '600',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#027A6B',
              },
            }}
          >
            Subscribe
          </Button>
        </Box>

        {/* Social Links */}
        <Box sx={{
          display: 'flex',
          gap: 1,
          mt: { xs: 2, lg: 0 },
        }}>
          {/* Facebook - Active */}
          <Box sx={{
            width: { xs: '36px', md: '40px' },
            height: { xs: '36px', md: '40px' },
            borderRadius: '50%',
            backgroundColor: '#039582',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#027A6B',
            },
          }}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M12.85 2.99H14.49V0.13C14.21 0.09 13.23 0 12.10 0C9.73 0 8.10 1.49 8.10 4.23V6.75H5.49V9.95H8.10V18H11.31V9.95H13.82L14.22 6.75H11.31V4.55C11.31 3.62 11.56 2.99 12.85 2.99Z" fill="white"/>
            </svg>
          </Box>

          {/* Other social icons - Inactive */}
          {[
            { name: 'Twitter', icon: 'M18.85 3.42C18.18 3.71 17.47 3.91 16.72 4.00C17.49 3.54 18.07 2.83 18.35 1.96C17.63 2.39 16.85 2.69 16.01 2.86C15.33 2.13 14.36 1.69 13.31 1.69C11.27 1.69 9.62 3.35 9.62 5.38C9.62 5.67 9.65 5.95 9.71 6.22C6.64 6.07 3.93 4.60 2.10 2.36C1.78 2.91 1.60 3.54 1.60 4.23C1.60 5.50 2.26 6.64 3.24 7.29C2.64 7.28 2.06 7.11 1.57 6.84V6.88C1.57 8.67 2.85 10.16 4.53 10.50C4.23 10.59 3.90 10.63 3.56 10.63C3.32 10.63 3.08 10.61 2.86 10.56C3.34 12.02 4.70 13.10 6.31 13.13C5.05 14.12 3.46 14.71 1.73 14.71C1.43 14.71 1.14 14.69 0.85 14.66C2.48 15.71 4.42 16.31 6.51 16.31C13.30 16.31 17.01 10.69 17.01 5.81C17.01 5.65 17.01 5.49 17.00 5.33C17.73 4.82 18.35 4.17 18.85 3.42Z' },
            { name: 'Pinterest', icon: 'M10.09 0C5.16 0 2.54 3.16 2.54 6.61C2.54 8.21 3.43 10.20 4.86 10.83C5.08 10.93 5.20 10.89 5.24 10.69C5.29 10.54 5.48 9.80 5.57 9.45C5.59 9.34 5.58 9.24 5.49 9.14C5.02 8.59 4.64 7.59 4.64 6.65C4.64 4.25 6.55 1.91 9.80 1.91C12.61 1.91 14.58 3.74 14.58 6.35C14.58 9.31 13.02 11.35 10.99 11.35C9.87 11.35 9.03 10.47 9.29 9.38C9.61 8.08 10.24 6.68 10.24 5.74C10.24 4.90 9.77 4.21 8.80 4.21C7.65 4.21 6.73 5.34 6.73 6.86C6.73 7.83 7.07 8.48 7.07 8.48C7.07 8.48 5.94 13.05 5.73 13.90C5.37 15.35 5.77 17.69 5.81 17.89C5.83 18.00 5.96 18.04 6.03 17.95C6.14 17.80 7.50 15.85 7.89 14.44C8.03 13.92 8.60 11.84 8.60 11.84C8.98 12.52 10.07 13.09 11.22 13.09C14.67 13.09 17.16 10.06 17.16 6.30C17.15 2.70 14.07 0 10.09 0Z' },
            { name: 'Instagram', icon: 'M9 4.5C6.51 4.5 4.5 6.51 4.5 9C4.5 11.49 6.51 13.5 9 13.5C11.49 13.5 13.5 11.49 13.5 9C13.5 6.51 11.49 4.5 9 4.5ZM9 12C7.34 12 6 10.66 6 9C6 7.34 7.34 6 9 6C10.66 6 12 7.34 12 9C12 10.66 10.66 12 9 12ZM14.7 4.35C14.7 4.95 14.25 5.4 13.65 5.4C13.05 5.4 12.6 4.95 12.6 4.35C12.6 3.75 13.05 3.3 13.65 3.3C14.25 3.3 14.7 3.75 14.7 4.35Z' }
          ].map((social, index) => (
            <Box key={social.name} sx={{
              width: { xs: '36px', md: '40px' },
              height: { xs: '36px', md: '40px' },
              borderRadius: '50%',
              backgroundColor: '#E6E6E6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '#D0D0D0',
              },
            }}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d={social.icon} fill="#4D4D4D"/>
              </svg>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Footer */}
      <Box sx={{
        width: '100%',
        backgroundColor: '#039582',
        py: { xs: 4, md: 6 },
        color: '#FFFFFF',
      }}>
        <Container maxWidth="xl" sx={{ px: { xs: 2, md: 6 } }}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 4, md: 6 },
          }}>
            {/* Footer Main Content */}
            <Box sx={{
              display: 'flex',
              flexDirection: { xs: 'column', lg: 'row' },
              gap: { xs: 4, md: 6, lg: 8 },
              alignItems: { xs: 'flex-start', lg: 'flex-start' },
            }}>
              {/* Logo */}
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}>
                <img 
                  src="/UnisynHub/Assets/Group 8.svg" 
                  alt="UnisynHub Logo" 
                  style={{
                    width: '59px',
                    height: '64px',
                  }}
                />
                <Typography sx={{
                  fontSize: '21.191px',
                  fontFamily: 'Poppins',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: 'normal',
                  color: '#01544E',
                }}>
                  UnisynHub
                </Typography>
              </Box>

              {/* Footer Links */}
              <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 3, sm: 6, md: 20, lg: 48 },
                flexWrap: 'wrap',
                ml: { md: 8, lg: 48 },
              }}>
                {/* UnisynHub Column */}
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}>
                  <Typography sx={{
                    fontSize: '16px',
                    fontFamily: 'Poppins, sans-serif',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '150%',
                    color: '#FFFFFF',
                  }}>
                    UnisynHub
                  </Typography>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                  }}>
                    {['Home', 'Shop', 'Contact Us'].map((link, linkIndex) => (
                      <Typography 
                        key={linkIndex} 
                        component="a" 
                        href={`#${link.toLowerCase().replace(' ', '-')}`}
                        sx={{
                          fontSize: '14px',
                          fontFamily: 'Poppins, sans-serif',
                          fontStyle: 'normal',
                          fontWeight: '500',
                          lineHeight: '150%',
                          color: '#FFFFFF',
                          textDecoration: 'none',
                          '&:hover': {
                            textDecoration: 'underline',
                          },
                        }}
                      >
                        {link}
                      </Typography>
                    ))}
                  </Box>
                </Box>

                {/* Products Column */}
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}>
                  <Typography sx={{
                    fontSize: '16px',
                    fontFamily: 'Poppins, sans-serif',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '150%',
                    color: '#FFFFFF',
                  }}>
                    Products
                  </Typography>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                  }}>
                    <Typography 
                      component="a" 
                      href="#/products/lipoderma"
                      sx={{
                        fontSize: '14px',
                        fontFamily: 'Poppins, sans-serif',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        lineHeight: '150%',
                        color: '#FFFFFF',
                        textDecoration: 'none',
                        '&:hover': {
                          textDecoration: 'underline',
                        },
                      }}
                    >
                      Lipoderma
                    </Typography>
                    <Typography 
                      component="a" 
                      href="#/products/equicent"
                      sx={{
                        fontSize: '14px',
                        fontFamily: 'Poppins, sans-serif',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        lineHeight: '150%',
                        color: '#FFFFFF',
                        textDecoration: 'none',
                        '&:hover': {
                          textDecoration: 'underline',
                        },
                      }}
                    >
                      equicent CTM
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Compliance Badges */}
            <Box sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 2, sm: 3 },
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}>
              {['FDA 361-Compliant', 'Research-Backed', 'HIPAA-Secure', 'Trusted by 500+ Clinics'].map((badge, index) => (
                <Box key={index} sx={{
                  backgroundColor: '#FFFFFF',
                  borderRadius: '8px',
                  border: '1px solid #CAC4D0',
                  padding: { xs: '4px 8px', md: '6px 12px' },
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}>
                  <img
                    src="/UnisynHub/Assets/Shield.svg"
                    alt="Shield icon"
                    style={{
                      width: '20px',
                      height: '20px',
                    }}
                  />
                  <Typography sx={{
                    fontSize: '14px',
                    fontFamily: 'Roboto, sans-serif',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '20px',
                    letterSpacing: '0.1px',
                    color: '#49454F',
                    textAlign: 'center',
                  }}>
                    {badge}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Copyright */}
            <Box sx={{
              py: 3,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <Typography sx={{
                fontSize: { xs: '12px', md: '14px' },
                fontFamily: 'Poppins, sans-serif',
                fontWeight: '400',
                lineHeight: { xs: '18px', md: '21px' },
                color: 'rgba(255, 255, 255, 0.7)',
                textAlign: 'center',
              }}>
                UnisynHub © 2025. All Rights Reserved
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default LaunchReadySplashPage;